import SlidesTabs from './slidesTabs';
import MoreTabs from './moreTabs';
import MarkTabs from './markTabs';
import NormalTabs from './normalTabs';
import ViewMoreLink from './viewMoreLink';

export { SlidesTabs, MoreTabs, MarkTabs, NormalTabs, ViewMoreLink };
